import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

function TableDataWrapper({ children, onClick, className }) {
    return (
        <div className={`table-data-wrapper ${className}`} onClick={onClick} role="presentation">
            {
                children
            }
        </div>
    );
}

TableDataWrapper.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

TableDataWrapper.defaultProps = {
    onClick: null,
    className: '',
};

export default TableDataWrapper;
